import ImageUserNotFound from 'assets/icons/Pak-Tani.png'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from 'reactstrap'

import { P } from 'components'
import PMBSelect from 'components/PMBSelect'
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import { useLazyFindAgentsQuery } from 'features/private-views/payable-notes/payableNotesApiSlice'
import { useSnackbar } from 'notistack'
import { Check, Info } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useFetchBanksQuery } from '../forms/formApiSlice'

const ModalDisbursement = ({
  isOpen,
  toggle,
  handleAddDisbursement,
  noHpFarmer,
  isDetailFarmer,
  isLoading,
  dataFormEdit,
  methodName,
  isBankExist,
  isEdit,
  agentSelected,
  isSwitchAgent,
  isAgentExist,
}) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { ownerData } = useSelector((s) => s.dashboard)
  const ownerUserId = ownerData?.userId
  const [findAgent, res] = useLazyFindAgentsQuery()
  const { isModalOpenAddAddressBook, searchAddressBook } = useSelector(
    (e) => e.addressBook,
  )

  const { data: banks } = useFetchBanksQuery()

  const banksOptions = banks?.map((item) => ({
    value: item?.code,
    label: item?.label,
    image: item?.logo,
  }))

  const [selectedMethod, setSelectedMethod] = useState(
    !isDetailFarmer ? 'bank' : 'agent',
  )
  const [accountNumber, setAccountNumber] = useState('')
  const [accountName, setAccountName] = useState('')
  const [agentInfo, setAgentInfo] = useState(null)
  const [agentPhone, setAgentPhone] = useState('')
  const [bankSelected, setBankSelected] = useState(null)
  const [primaryAgent, setPrimaryAgent] = useState(false)

  const [savedContacts, setSavedContacts] = useState([])

  const accountNumberRef = useRef(null)
  const agentPhoneRef = useRef(null)

  const resetState = () => {
    setSelectedMethod(!isDetailFarmer ? 'bank' : 'agent')
    setAccountName('')
    setAccountNumber('')
    setBankSelected(null)
    setAgentPhone('')
    setAgentInfo(null)
    setPrimaryAgent(false)
  }

  const handleCheckAgent = async (phoneOrEmail) => {
    if (isDetailFarmer && noHpFarmer === phoneOrEmail) {
      enqueueSnackbar(
        'Email atau Nomor handphone agen tidak boleh sama dengan nomor farmer!',
        {
          variant: 'error',
        },
      )
      return
    }

    if (phoneOrEmail) {
      const res = await findAgent({
        s: phoneOrEmail,
      })

      setAgentInfo(res?.data?.[0] || null)
      if (res?.data?.length === 0) {
        enqueueSnackbar('Maaf, Agen tidak ditemukan!', {
          variant: 'error',
        })
      }
    } else {
      setAgentInfo(null)
      enqueueSnackbar('Email atau Nomor handphone agen harap diisi!', {
        variant: 'error',
      })
    }
  }

  const handleSubmit = () => {
    const data = {
      method: selectedMethod,
      agentPhone: selectedMethod === 'agent' ? agentPhone : null,
      agentInfo: selectedMethod === 'agent' ? agentInfo : null,
      bankDetails:
        selectedMethod === 'bank'
          ? { accountNumber, bankSelected, accountName }
          : null,
      isDefault: primaryAgent ? 1 : 0,
    }

    // SAVE TO LOCALSTORAGE
    if (selectedMethod === 'agent' && agentInfo) {
      const storageKey = `disbursementAddressBook-${ownerUserId}`
      const storedData = JSON.parse(localStorage.getItem(storageKey) || '[]')

      const contactToStore = {
        relationName: agentInfo.relationName,
        relationPhoneNumber: agentInfo.relationPhoneNumber,
      }

      const filteredData = storedData.filter(
        (item) => item.relationPhoneNumber !== agentInfo.relationPhoneNumber,
      )

      filteredData.unshift(contactToStore)

      const trimmedData = filteredData.slice(0, 3)

      localStorage.setItem(storageKey, JSON.stringify(trimmedData))
    }

    handleAddDisbursement(data)

    resetState()
  }

  const getRadioStyle = (method) => {
    const isActive = selectedMethod === method
    return {
      backgroundColor: isActive ? '#ECFAFF' : '#FFFFFF',
      border: isActive ? '1px solid #8ABBCC' : '1px solid #EAECF0',
      padding: 16,
      borderRadius: 8,
      cursor: 'pointer',
    }
  }

  const handleSelectedContact = (selectedAgen) => {
    if (Object.keys(selectedAgen).length !== 0) {
      setAgentPhone(
        selectedAgen?.relationPhoneNumber ?? selectedAgen?.relationEmail ?? '',
      )
      handleCheckAgent(
        selectedAgen?.relationPhoneNumber ?? selectedAgen?.relationEmail ?? '',
      )
    } else {
      setAgentPhone('')
      setAgentInfo(null)
    }
  }

  const isDisabledButton = () => {
    if (isLoading) return false
    if (selectedMethod === 'bank') {
      return accountNumber !== '' && bankSelected && accountName !== ''
    } else if (selectedMethod === 'agent') {
      return !!agentInfo
    }
    return false
  }

  // HANDLE EDIT
  useEffect(() => {
    // BANK
    if (isEdit && isOpen && dataFormEdit && methodName === 'bank') {
      setAccountName(dataFormEdit?.bankAccountName ?? '')
      setAccountNumber(dataFormEdit?.bankAccountNumber ?? '')
      setBankSelected(
        banksOptions?.find((item) => item?.value === dataFormEdit?.bankCode),
      )
    }
    // AGENT
    if (isEdit && isOpen && agentSelected && methodName === 'agent') {
      setAgentPhone(
        agentSelected?.agentverifiedprofile?.phoneNumber ?? noHpFarmer ?? '',
      )
      setAgentInfo(agentSelected)
      setPrimaryAgent(isSwitchAgent)
    }
    // SET METHOD
    if (methodName) {
      setSelectedMethod(methodName)
    }
  }, [isOpen, dataFormEdit, methodName, isEdit])

  // HANDLE AUTO FOCUS
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (selectedMethod === 'bank') {
          accountNumberRef.current?.focus()
        } else if (selectedMethod === 'agent') {
          agentPhoneRef.current?.focus()
        }
      }, 0)
    }
  }, [selectedMethod, isOpen])

  // HANDLE ADDRESS BOOK FROM LOCALSTORAGE
  useEffect(() => {
    const storageKey = `disbursementAddressBook-${ownerUserId}`
    const savedData = JSON.parse(localStorage.getItem(storageKey) || '[]')
    setSavedContacts(savedData)
  }, [ownerUserId, isOpen])

  return (
    <>
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={() => {
          dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
        }}
        isOutsideAddressBook
        isPhoneVerified
        isEmailVerified
      />

      {
        <Modal
          isOpen={isOpen}
          toggle={() => {
            toggle()
            resetState()
          }}
          centered
          data-testid="farmer-disbursement-modal"
        >
          <ModalHeader
            toggle={() => {
              toggle()
              resetState()
            }}
          >
            {isEdit
              ? `Ubah ${methodName === 'agent' ? 'agen' : 'bank'}`
              : 'Tambah metode'}
          </ModalHeader>
          <ModalBody>
            <Form>
              {/* CHOOSE METHOD */}
              <FormGroup>
                {/* BANK */}
                {!isDetailFarmer &&
                  (!isBankExist || isEdit) &&
                  (!isEdit || methodName !== 'agent') && (
                    <div
                      className="mb-3"
                      style={getRadioStyle('bank')}
                      onClick={() => {
                        resetState()
                        setSelectedMethod('bank')
                      }}
                      data-testid="farmer-disbursement-method-bank"
                    >
                      <Input
                        type="radio"
                        name="paymentMethod"
                        value="bank"
                        checked={selectedMethod === 'bank'}
                        onChange={() => {
                          resetState()
                        }}
                        style={{ cursor: 'pointer' }}
                      />
                      <Label
                        className="ms-2 fw-semibold"
                        style={{ cursor: 'pointer' }}
                      >
                        Transfer bank
                      </Label>
                      <p
                        className="text-muted text-sm ms-4 mb-0"
                        style={{ color: '#475467' }}
                      >
                        Pembayaran akan masuk ke rekening bank anggota
                      </p>
                    </div>
                  )}
                {/* END BANK */}

                {/* AGENT */}
                {(isDetailFarmer ||
                  (!isAgentExist && !isEdit) ||
                  (isEdit && methodName !== 'bank')) && (
                  <div
                    style={getRadioStyle('agent')}
                    onClick={() => {
                      resetState()
                      setSelectedMethod('agent')
                    }}
                    data-testid="farmer-disbursement-method-agent"
                  >
                    <Input
                      type="radio"
                      name="paymentMethod"
                      value="agent"
                      checked={selectedMethod === 'agent'}
                      onChange={() => {
                        resetState()
                        setSelectedMethod('agent')
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                    <Label
                      className="ms-2 fw-semibold"
                      style={{ cursor: 'pointer' }}
                    >
                      Pembayaran lewat agen
                    </Label>
                    <p
                      className="text-muted text-sm ms-4 mb-0"
                      style={{ color: '#475467' }}
                    >
                      Pembayaran akan ditransfer ke agen, dan diteruskan secara
                      tunai ke anggota
                    </p>
                  </div>
                )}
                {/* END AGENT */}
              </FormGroup>
              {/* END CHOOSE METHOD */}

              <Label
                className="fw-semibold mb-3"
                style={{ color: '#344054', fontSize: '20px' }}
              >
                Informasi {selectedMethod === 'bank' ? 'rekening' : 'agen'}
              </Label>

              {/* FORM TRANSFER BANK */}
              {selectedMethod === 'bank' && !isDetailFarmer && (
                <>
                  <FormGroup>
                    <Label for="accountNumber">Nomor rekening</Label>
                    <Input
                      type="text"
                      id="accountNumber"
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      placeholder="Masukkan nomor rekening"
                      innerRef={accountNumberRef}
                      data-testid="farmer-disbursement-account-number"
                    />
                  </FormGroup>
                  {/* SELECT BANK */}
                  <FormGroup>
                    <label className="mb-1">Bank</label>
                    <PMBSelect
                      value={bankSelected}
                      onChange={(selected) => setBankSelected(selected)}
                      options={banksOptions}
                      placeholder="Pilih bank"
                      testId="farmer-disbursement-bank-select"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="accountName">Nama pemilik rekening</Label>
                    <Input
                      type="text"
                      id="accountName"
                      value={accountName}
                      onChange={(e) => setAccountName(e.target.value)}
                      placeholder="Masukkan nama pemilik rekening"
                      data-testid="farmer-disbursement-account-name"
                    />
                  </FormGroup>
                </>
              )}
              {/* END FORM TRANSFER BANK */}

              {/* FORM AGENT */}
              {selectedMethod === 'agent' && (
                <>
                  <FormGroup>
                    <div>
                      <InputAddressBook
                        title="Agent"
                        onSelectContact={handleSelectedContact}
                        fieldName="phoneNumber"
                        editValue={
                          agentInfo?.relationPhoneNumber
                            ? `${agentInfo?.relationName} (${agentInfo?.relationPhoneNumber})`
                            : agentInfo?.relationEmail
                              ? `${agentInfo?.relationName} (${agentInfo?.relationEmail})`
                              : agentInfo?.relationName
                        }
                        onClickAdd={(localSearch) =>
                          dispatch(setSearchAddressBook(localSearch))
                        }
                        innerRef={agentPhoneRef}
                        isPhoneVerified
                        isEmailVerified
                      />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                        className="pt-3"
                      >
                        <Info size="16" style={{ color: '#016386' }} />
                        <P size="small">
                          Daftar kontak yang dapat dicari hanya yang berstatus
                          terverifikasi
                        </P>
                      </div>
                    </div>
                  </FormGroup>

                  {/* RECEIVED FROM LOCALSTORAGE */}
                  {savedContacts?.length > 0 && !agentInfo?.relationName && (
                    <div
                      className="d-flex gap-2 my-4"
                      style={{ minWidth: '100%', overflow: 'auto' }}
                    >
                      {savedContacts.map((contact, i) => {
                        const displayName = contact.relationPhoneNumber
                          ? `${contact.relationName} (${contact.relationPhoneNumber})`
                          : `${contact.relationName}${contact.relationEmail ? ` (${contact.relationEmail})` : ''}`

                        return (
                          <div
                            key={i}
                            onClick={() => {
                              setAgentInfo({
                                relationName: contact.relationName,
                                relationPhoneNumber:
                                  contact.relationPhoneNumber,
                                relationEmail: contact.relationEmail,
                              })
                              dispatch(setSearchAddressBook(displayName))
                            }}
                            className="rounded p-3 bg-gray-50 hover-100 pointer"
                          >
                            <div className="d-flex align-items-center gap-2">
                              <span>{displayName}</span>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {/* END RECEIVED FROM LOCALSTORAGE */}

                  {agentInfo && (
                    <>
                      <div
                        style={{
                          border: '1px solid #039855',
                          backgroundColor: '#F6FEF9',
                          borderRadius: 8,
                          padding: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          marginBottom: '10px',
                        }}
                      >
                        <img
                          src={
                            agentInfo?.partnership?.logo || ImageUserNotFound
                          }
                          alt={
                            agentInfo?.partnership?.name ??
                            agentInfo?.agentverifiedprofile?.name ??
                            agentInfo?.relationName ??
                            '-'
                          }
                          style={{ width: 30, height: 30, borderRadius: '50%' }}
                          loading="lazy"
                        />
                        <span>
                          {agentInfo?.partnership?.name ??
                            agentInfo?.agentverifiedprofile?.name ??
                            agentInfo?.relationName ??
                            '-'}
                        </span>
                        <span style={{ marginLeft: 'auto', color: '#039855' }}>
                          <Check />
                        </span>
                      </div>
                    </>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '10px',
                      marginLeft: 'auto',
                    }}
                  >
                    <Input
                      disabled={!agentInfo}
                      checked={primaryAgent}
                      defaultChecked={false}
                      type="checkbox"
                      onChange={(e) => setPrimaryAgent(e.target.checked)}
                      data-testid="farmer-disbursement-primary-agent"
                      style={{
                        cursor: agentInfo && 'pointer',
                        border: !agentInfo
                          ? '1px solid grey'
                          : '1px solid #016286',
                        backgroundColor: !agentInfo && '#e5e5e5',
                      }}
                    />
                    <Label
                      style={{
                        marginBottom: 0,
                        color: !agentInfo && '#C1BFBF',
                      }}
                    >
                      Jadikan Agen sebagai utama
                    </Label>
                  </div>
                </>
              )}
              {/* END FORM AGENT */}
            </Form>
          </ModalBody>

          <div className="d-flex gap-3 m-3">
            <Button
              className="button-cancel"
              onClick={() => {
                toggle()
                resetState()
              }}
              outline
              block
              data-testid="farmer-disbursement-cancel-button"
            >
              Batal
            </Button>
            <Button
              color="primary"
              disabled={!isDisabledButton()}
              onClick={handleSubmit}
              block
              data-testid="farmer-disbursement-submit-button"
            >
              {isLoading ? <Spinner size="sm" /> : isEdit ? 'Simpan' : 'Tambah'}
            </Button>
          </div>
        </Modal>
      }
    </>
  )
}

export default ModalDisbursement
